import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import PrefillView from './Prefill.view';
import steps from './PrefillSteps';
import { getPublicClientConfig, createPrefill, updatePrefill } from '../../services/truststartService';

function NoView() {
  return null;
}

export default function Prefill(props) {
  const { ref } = queryString.parse(props.location.search);
  const [progress, setProgress] = useState({ step: 0, error: false });
  const [config, setConfig] = useState({ loading: true, stepViews: [NoView] });
  const [validations, setValidations] = useState({});
  const [formData, setFormData] = useState({
    phone: '',
    verify: '',
    ssn: '',
  });

  useEffect(() => {
    async function fetchConfig() {
      const result = await getPublicClientConfig(null, ref);
      setConfig({
        ...result,
        stepViews: steps(result.prefill),
      });
    }
    fetchConfig();
  }, [ref]);

  const onFieldChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const onNext = async () => {
    setProgress({
      ...progress,
      loading: true,
    });
    if (progress.step < 1) {
      const result = await createPrefill(ref, formData.phone);
      if (result.error) {
        setProgress({
          ...progress,
          error: 'Unable to send SMS',
        });
      } else {
        setProgress({
          step: 1,
          id: result.id,
          error: false,
        });
      }
      return;
    }
    const result = await updatePrefill(ref, progress.id, formData);
    if (result.error) {
      setProgress({
        ...progress,
        error: result.error,
      });
      return;
    }
    if (result.canRedirect) {
      const href = `${window.location.origin}/application-form.html${props.location.search}&prefill=${progress.id}`;
      window.location.href = href;
      return;
    }
    if (!result.verified) {
      const message = 'Phone has not been verified';
      setProgress({
        ...progress,
        error: result.responseMessage || message,
      });
      return;
    }
    setProgress({
      ...progress,
      step: Math.min(progress.step + 1, config.stepViews.length - 1),
      error: false,
    });
  };

  const { component: StepView, validationConfig } = config.stepViews[progress.step];

  return (
    <PrefillView
      config={config}
      formData={formData}
      validationConfig={validationConfig}
      onNext={onNext}
      onFormValidated={setValidations}
      error={progress.error}
      loading={config.loading || progress.loading}
    >
      <StepView
        formData={formData}
        validations={validations}
        onChange={onFieldChange}
      />
    </PrefillView>
  );
}
